import { render, staticRenderFns } from "./appendix-info.vue?vue&type=template&id=c9866fe8&scoped=true"
import script from "./appendix-info.vue?vue&type=script&lang=js"
export * from "./appendix-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9866fe8",
  null
  
)

export default component.exports